module.exports = __webpack_public_path__ + "img/logout.f20bba59.png";